import { render } from "./ColorBackgroundPage.vue?vue&type=template&id=29a5c5ef&ts=true"
import script from "./ColorBackgroundPage.vue?vue&type=script&lang=ts"
export * from "./ColorBackgroundPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__